import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp, Shield, Target } from 'lucide-react';

export const HeroSection = () => {
  const handleGetStarted = () => {
    window.open('https://forms.gle/ZfyxmjxEBEwmtEhs8', '_blank');
  };

  const handleContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLearnMore = () => {
    const approachSection = document.getElementById('approach');
    if (approachSection) {
      approachSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-green-50 pt-16">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-pulse"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-green-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-pulse" style={{animationDelay: '2s'}}></div>
        <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-blue-100 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse" style={{animationDelay: '4s'}}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-32">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/70 backdrop-blur-sm border border-blue-200 text-blue-700 text-sm font-medium mb-8 shadow-lg">
            <TrendingUp className="w-4 h-4 mr-2" />
            Portfolio Management Services
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-slate-800 mb-8 leading-tight">
            <span className="bg-gradient-to-r from-blue-600 via-blue-700 to-green-600 bg-clip-text text-transparent">
              IndexMaster
            </span>
            <br />
            <span className="text-slate-700">Investment Approach</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-slate-600 mb-12 max-w-4xl mx-auto leading-relaxed">
            Achieve Superior Risk-Adjusted Returns with Our Rule-Based Active Indexing Strategy.
            <span className="block mt-2 text-lg font-medium text-blue-700">
              The Smarter Way to Invest - Best of Active & Passive
            </span>
          </p>

          {/* Key Features Grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-12 max-w-4xl mx-auto">
            <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-blue-100 shadow-lg hover:shadow-xl transition-all duration-300">
              <Shield className="w-8 h-8 text-blue-600 mx-auto mb-3" />
              <h3 className="text-lg font-semibold text-slate-800 mb-2">Reduced Human Bias</h3>
              <p className="text-slate-600 text-sm">Rule-based approach minimizes emotional decision-making</p>
            </div>
            <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-green-100 shadow-lg hover:shadow-xl transition-all duration-300">
              <Target className="w-8 h-8 text-green-600 mx-auto mb-3" />
              <h3 className="text-lg font-semibold text-slate-800 mb-2">Long-Term Growth</h3>
              <p className="text-slate-600 text-sm">Focus on capital appreciation over extended periods</p>
            </div>
            <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-blue-100 shadow-lg hover:shadow-xl transition-all duration-300">
              <TrendingUp className="w-8 h-8 text-blue-600 mx-auto mb-3" />
              <h3 className="text-lg font-semibold text-slate-800 mb-2">Superior Returns</h3>
              <p className="text-slate-600 text-sm">Consistent risk-adjusted performance through tactical allocation</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              onClick={handleGetStarted}
              size="lg"
              className="bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white px-8 py-4 rounded-xl text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 group"
            >
              Open Account Now
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              onClick={handleContact}
              variant="outline" 
              size="lg"
              className="border-2 border-blue-300 text-blue-700 hover:bg-blue-50 px-8 py-4 rounded-xl text-lg font-semibold backdrop-blur-sm bg-white/70 hover:shadow-lg transition-all duration-300"
            >
              Contact Us
            </Button>
            <Button 
              onClick={handleLearnMore}
              variant="outline" 
              size="lg"
              className="border-2 border-green-300 text-green-700 hover:bg-green-50 px-8 py-4 rounded-xl text-lg font-semibold backdrop-blur-sm bg-white/70 hover:shadow-lg transition-all duration-300"
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};